import AccountService from "./AccountService"

class AnalyticsService
{
    async getAnalytics(options: any): Promise<any> {
        return AccountService.sendRequest('ANALYTICS_GET_DATA', options);
    }

    async getDimensionData(options: any): Promise<any> {
        return AccountService.sendRequest('ANALYTICS_GET_DIMENSION_DATA', options);
    }

    async getLocationData(options: any): Promise<any> {
        return AccountService.sendRequest('ANALYTICS_GET_LOCATION_DATA', options);
    }

    async getAnchorData(options: any): Promise<any> {
        return AccountService.sendRequest('ANALYTICS_GET_ANCHOR_DATA', options);
    }

    logEvent(params: any) {
        return AccountService.sendRequest('ANALYTICS_EVENT', {event: params});
    }
}

const g_analyticsService = new AnalyticsService();
export default g_analyticsService;
